import { render } from "./LeaveTopButtons.vue?vue&type=template&id=21991774"
import script from "./LeaveTopButtons.vue?vue&type=script&lang=js"
export * from "./LeaveTopButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__